const PROFESSIONAL_BACKGROUND_COLORS = [
  // Vibrant, professional, and varied color palette (no whites or very light colors)
  "#2563eb", // Blue 600
  "#10b981", // Emerald 500
  "#f43f5e", // Rose 500
  "#f59e42", // Orange 400
  "#7c3aed", // Violet 600
  "#06b6d4", // Cyan 500
  "#fbbf24", // Amber 400
  "#6366f1", // Indigo 500
  "#ef4444", // Red 500
  "#db2777", // Pink 600
  "#0ea5e9", // Sky 500
  "#a3e635", // Lime 400
  "#f472b6", // Pink 400
  "#22d3ee", // Cyan 400
  "#8b5cf6", // Violet 500
  "#f87171", // Red 400
  "#14b8a6", // Teal 500
  "#facc15", // Yellow 400
  "#34d399", // Green 400
  "#3b82f6", // Blue 500
  "#059669", // Emerald 600
  "#eab308", // Yellow 500
  "#f59e42", // Orange 400 (repeat for vibrancy)
  "#a21caf", // Purple 800
  "#0d9488", // Teal 600
  "#f472b6", // Pink 400 (repeat for vibrancy)
  "#f87171", // Red 400 (repeat for vibrancy)
  "#4ade80", // Green 400
  "#fbbf24", // Amber 400 (repeat for vibrancy)
  "#818cf8", // Indigo 400
  "#fca5a5", // Red 300
  "#38bdf8", // Sky 400
  "#fde047", // Yellow 300
  "#a3e635", // Lime 400 (repeat for vibrancy)
  "#facc15", // Yellow 400 (repeat for vibrancy)
  "#c026d3", // Fuchsia 600
  "#e11d48", // Rose 700
  "#22d3ee", // Cyan 400 (repeat for vibrancy)
  "#16a34a", // Green 600
  "#fcd34d", // Amber 300
  "#7dd3fc", // Sky 300
  "#64748b", // Slate 500
  "#d97706", // Amber 700
  "#fca5a5", // Red 300 (repeat for vibrancy)
  "#a78bfa", // Violet 300
  "#6d28d9", // Violet 800
  "#0369a1", // Sky 800
  "#fbbf24", // Amber 400 (repeat for vibrancy)
  "#f59e42", // Orange 400 (repeat for vibrancy)
  "#0ea5e9", // Sky 500 (repeat for vibrancy)
  "#f43f5e", // Rose 500 (repeat for vibrancy)
  "#10b981", // Emerald 500 (repeat for vibrancy)
  "#2563eb", // Blue 600 (repeat for vibrancy)
  "#7c3aed", // Violet 600 (repeat for vibrancy)
  "#06b6d4", // Cyan 500 (repeat for vibrancy)
];

export default PROFESSIONAL_BACKGROUND_COLORS as string[];